import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CandidateSelectedObj, candidatesUpdate, getCandidateForm } from '@collections/candidates';
import { DangerAlert } from '@shared/alert';
import * as FormActions from '@shared/form/store/form.actions';
import { CandidateFormAdapter } from '@shared/models';

import { SourceStatus } from '../+source/candidate-source.component';

@Component({
  selector: 'mojo-candidate-details',
  templateUrl: './candidate-details.container.html',
  styleUrls: ['./candidate-details.container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateDetailsComponent {
  candidate$: Observable<CandidateFormAdapter> = this.store.pipe(
    select(CandidateSelectedObj.getCandidatesSelected()),
    switchMap(({ id }) => this.store.pipe(select(getCandidateForm, { id }))),
  );

  form = new UntypedFormGroup({
    source: new UntypedFormControl(),
    sourceNote: new UntypedFormControl(),
  });

  constructor(private store: Store<{}>) {}

  valid(): boolean {
    return [SourceStatus.Other, SourceStatus.Referral].includes(this.form.controls.source.value)
      ? !!this.form.controls.sourceNote.value
      : !!this.form.controls.source.value;
  }

  submit(id: number) {
    if (this.valid()) {
      if (![SourceStatus.Other, SourceStatus.Referral].includes(this.form.controls.source.value)) {
        this.form.controls.sourceNote.setValue('');
      }
      const newCandidate = {
        ...CandidateFormAdapter.toCandidate(this.form.getRawValue()),
        id,
      };
      this.store.dispatch(candidatesUpdate({ payload: newCandidate }));
      this.store.dispatch(FormActions.formSubmit({}));
    } else {
      this.form.markAllAsTouched();
      this.store.dispatch(new DangerAlert('You must enter notes before saving.'));
    }
  }

  close() {
    this.store.dispatch(FormActions.formClose({}));
  }
}
